const unifyHex = (hex?: string) =>
    (hex?.length === 4 && `${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`.toUpperCase()) ||
    hex?.toUpperCase();

export const isSameHex = (hex1: string, hex2: string) => unifyHex(hex1) === unifyHex(hex2);
